import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import "./tag-group.script";
export function RuiTagList({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-tag-list": true,
    class: cx("rui-tag-group__list", className),
    children
  });
}
export function RuiTag({
  value,
  label,
  children,
  class: className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsxs("span", {
    ...props,
    "data-tag": true,
    "data-value": value,
    "data-label": label,
    class: cx("rui-tag", className),
    "aria-disabled": disabled ? "true" : void 0,
    children: [children, /* @__PURE__ */jsx(RuiTagRemove, {})]
  });
}
export function RuiTagRemove({
  children,
  class: className,
  aria,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Remove"),
    type: "button",
    "data-tag-remove": true,
    class: cx("rui-tag__remove", className),
    children: children ?? /* @__PURE__ */jsx("span", {
      "aria-hidden": "true",
      children: "\xD7"
    })
  });
}
function TagGroupShell({
  children
}) {
  return /* @__PURE__ */jsx("div", {
    class: "rui-tag-group",
    "data-ref": "root",
    children
  });
}
export function RuiTagGroup({
  tags,
  children,
  ...props
}) {
  if (tags != null) {
    return /* @__PURE__ */jsx("rui-tag-group", {
      ...props,
      children: /* @__PURE__ */jsx(TagGroupShell, {
        children: /* @__PURE__ */jsx(RuiTagList, {
          children: tags.map(tag => /* @__PURE__ */jsx(RuiTag, {
            value: tag.value,
            label: typeof tag.label === "string" ? tag.label : void 0,
            disabled: tag.disabled,
            children: tag.label
          }))
        })
      })
    });
  }
  return /* @__PURE__ */jsx("rui-tag-group", {
    ...props,
    children: /* @__PURE__ */jsx(TagGroupShell, {
      children
    })
  });
}